import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadSitesSummaryAction,
  ILoadSitesSummarySuccessAction,
  LoadSitesSummaryErrorAction,
} from '../actions/load-sites-summary'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadSitesSummaryAction =
  | ILoadSitesSummaryAction
  | ILoadSitesSummarySuccessAction
  | LoadSitesSummaryErrorAction

const init = (state: IServicePerformanceState, action: LoadSitesSummaryAction) => ({
  ...state,
  sitesSummary: {
    ...initialState.sitesSummary,
    status: action.status,
  },
})

const success = (state: IServicePerformanceState, action: LoadSitesSummaryAction) => ({
  ...state,
  sitesSummary: {
    ...initialState.sitesSummary,
    status: action.status,
    data: (action as ILoadSitesSummarySuccessAction).data,
  },
})

const failure = (state: IServicePerformanceState, action: LoadSitesSummaryAction) => ({
  ...state,
  sitesSummary: {
    ...initialState.sitesSummary,
    status: action.status,
    error: (action as LoadSitesSummaryErrorAction).error,
  },
})

export const loadSitesSummaryReducer = createAsyncReducer(initialState, init, success, failure)
